export const HEADER_BUTTONS_REGION_ID = 'headerButtonsRegionId';
